import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 mt-16" data-id="element-366" data-mp="32wd0e9mw79qd">
      <div className="max-w-4xl mx-auto px-4 text-center text-sm" data-id="element-367" data-mp="3gfsjo3v2keir">
        <p className="mb-4" data-id="element-368" data-mp="3gh3swj7aaeh9">
          หมายเหตุ: ผลิตภัณฑ์นี้เป็นอาหารเสริม ไม่ใช่ยา
          ไม่มีผลในการป้องกันหรือรักษาโรค ผลลัพธ์อาจแตกต่างกันในแต่ละบุคคล
          ควรใช้ร่วมกับการปรับพฤติกรรมการนอนหลับ
          และปรึกษาแพทย์หรือเภสัชกรก่อนหากมีโรคประจำตัวหรือกินยาอยู่
        </p>
        <p className="mb-8" data-id="element-369" data-mp="3ucxs2ai99ph6">
          บทความนี้เป็น Advertorial สร้างขึ้นร่วมกับ BLB® Liposomal Magnesium
        </p>
        <div className="flex justify-center gap-6 mb-8" data-id="element-370" data-mp="3lec768pb9yd8">
          <a href="#" className="hover:text-white transition-colors" data-id="element-371" data-mp="3ldu34pweqfur">
            ข้อตกลงและเงื่อนไข
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-372" data-mp="3qfjiuiukrhp6">
            นโยบายความเป็นส่วนตัว
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-373" data-mp="2ey9zdwbg4pnv">
            ติดต่อเรา
          </a>
        </div>
        <p data-id="element-374" data-mp="3l90lhpgqmmw3">
          &copy; {new Date().getFullYear()} HealthDaily. All rights reserved.
        </p>
      </div>
    </footer>;
}